import { Form } from 'react-bootstrap';
import './style.css'

const RadioGroup = ({data, inputs, handleChange, disabled}) => {

  return (
    <Form.Group className={data.class} controlId={data.nameForm}>
			<Form.Label>{data.name}</Form.Label>
			{data.options?.map((option, index) => {
				return (
					<Form.Check
						key={index}
						id={`${data.nameForm}-${data.type}-${index}`}
						type="radio"
						label={option.text}
						required={data.required}
						name={data.nameForm}
						value={option.value}
						disabled={disabled}
						onChange={handleChange}
						checked={inputs[data.nameForm] === option.value ? true : false}
					/>
				)
			})}
		</Form.Group>
  )
}

export default RadioGroup
